export default "__VITE_ASSET__BYAZoPN1__"